import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import {ASSET_CONDITION_OPTIONS, newDesignInputCustomClassesViewOnly} from "../../../constants";
import {choiceValue, dateToMoment, momentToDate} from "../../utils";
import {END_DATE_SHOULD_BE_AFTER_START} from "../../../../Trades/constants";


const OtherAssetForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    sub_category: choiceValue(defaults.sub_category),
    name: defaults.name,
    value: decimalStrToNumber(defaults.value),
    brand_or_manufacture: defaults.brand_or_manufacture,
    value_date: dateToMoment(defaults.value_date),
    purchase_amount: decimalStrToNumber(defaults.purchase_amount),
    purchase_date: dateToMoment(defaults.purchase_date),
    end_date: dateToMoment(defaults.end_date),
    condition: choiceValue(defaults.condition),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      value_date: momentToDate(model.value_date),
      purchase_date: momentToDate(model.purchase_date),
      end_date: momentToDate(model.end_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <InputFormElement
            label="Kategorie"
            value={model.sub_category}
            error={errors.sub_category}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            custom_classes={inputClasses}
            required
            disabled={viewOnly}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Marke / Hersteller / Künstler"
          value={model.brand_or_manufacture}
          error={errors.brand_or_manufacture}
          onChange={handleModelChange('brand_or_manufacture')}
          dataId={'brand_or_manufacture-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Wert / Bewertung"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Bewertungsdatum"
          disableFuture
          value={model.value_date}
          error={errors.value_date}
          onChange={handleModelChange('value_date')}
          dataId={'value_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Kaufpreis"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.purchase_amount}
          error={errors.purchase_amount}
          onChange={handleModelChange('purchase_amount')}
          dataId={'purchase_amount-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <SelectFormElementV2
          label="Zustand"
          value={model.condition}
          options={ASSET_CONDITION_OPTIONS}
          onChange={handleModelChange('condition')}
          dataId={'condition-input'}
          custom_classes={inputClasses}
          disabled={viewOnly}
          addEmptyOption
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Erwerbsdatum"
          value={model.purchase_date}
          error={errors.purchase_date}
          onChange={handleModelChange('purchase_date')}
          dataId={'acquisition_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Laufzeit bis"
          value={model.end_date}
          error={errors.end_date}
          minDate={model.purchase_date || undefined}
          minError={END_DATE_SHOULD_BE_AFTER_START}
          onChange={handleModelChange('end_date')}
          dataId={'end_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

OtherAssetForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default OtherAssetForm;